import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiDeleteOutline } from "@mdi/js";
import {
  Button,
  Drawer,
  Input,
  Switch,
  TextArea,
  TextField,
} from "@heroui/react";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";

const FaqFormDrawer: React.FC = observer(() => {
  const store = feedbackSettingsStore;
  const {
    faqFormOpen,
    isFaqEditing,
    faqEditingUuid,
    faqForm,
    faqFormErrors,
    faqSubmitAttempted,
    faqSubmitting,
  } = store;

  const fieldError = (field: string) =>
    faqSubmitAttempted ? faqFormErrors[field] : undefined;

  const handleDelete = () => {
    if (!faqEditingUuid) return;
    store.closeFaqForm();
    store.requestDelete({
      kind: "faq",
      uuid: faqEditingUuid,
      label: faqForm.question,
    });
  };

  return (
    <Drawer.Backdrop
      isOpen={faqFormOpen}
      onOpenChange={(open) => {
        if (!open) store.closeFaqForm();
      }}
      className="fb-drawer-backdrop"
    >
      <Drawer.Content placement="right" className="fb-drawer-content">
        <Drawer.Dialog className="fb-drawer-dialog">
          <Drawer.CloseTrigger />
          <Drawer.Header className="fb-drawer-header">
            <Drawer.Heading>
              {isFaqEditing ? "Редактирование вопроса" : "Новый вопрос FAQ"}
            </Drawer.Heading>
            <p className="fb-drawer-subtitle">
              Вопрос и ответ отображаются в блоке FAQ на сайте
            </p>
          </Drawer.Header>

          <Drawer.Body className="fb-drawer-body">
            <div className="fbs-form-field">
              <label className="fbs-form-field__label">Вопрос *</label>
              <TextField fullWidth isInvalid={!!fieldError("question")}>
                <Input
                  value={faqForm.question}
                  onChange={(e) =>
                    store.setFaqField("question", e.target.value)
                  }
                  placeholder="Как записаться на сервис?"
                />
              </TextField>
              {fieldError("question") && (
                <span className="fbs-form-field__error">
                  {fieldError("question")}
                </span>
              )}
            </div>

            <div className="fbs-form-field">
              <label className="fbs-form-field__label">Ответ *</label>
              <TextArea
                fullWidth
                rows={5}
                value={faqForm.answer}
                onChange={(e) => store.setFaqField("answer", e.target.value)}
                placeholder="Опишите ответ..."
                aria-invalid={!!fieldError("answer")}
              />
              {fieldError("answer") && (
                <span className="fbs-form-field__error">
                  {fieldError("answer")}
                </span>
              )}
            </div>

            <div className="fbs-visibility-row">
              <span className="fbs-form-field__label">Видимость</span>
              <Switch
                className="fbs-switch"
                isSelected={faqForm.is_active}
                onChange={(checked) => store.setFaqField("is_active", checked)}
                aria-label="Видимость вопроса"
              >
                <Switch.Control>
                  <Switch.Thumb />
                </Switch.Control>
              </Switch>
            </div>
          </Drawer.Body>

          <Drawer.Footer className="fbs-drawer-footer">
            <div className="fbs-drawer-footer__actions">
              {isFaqEditing ? (
                <Button
                  variant="ghost"
                  className="fbs-drawer-footer__delete"
                  onPress={handleDelete}
                >
                  <Icon path={mdiDeleteOutline} size={0.8} />
                  Удалить
                </Button>
              ) : (
                <span />
              )}
              <div className="fbs-drawer-footer__spacer" />
              <Button variant="tertiary" onPress={() => store.closeFaqForm()}>
                Отмена
              </Button>
              <Button
                variant="primary"
                onPress={() => void store.submitFaq()}
                isPending={faqSubmitting}
              >
                Сохранить
              </Button>
            </div>
          </Drawer.Footer>
        </Drawer.Dialog>
      </Drawer.Content>
    </Drawer.Backdrop>
  );
});

FaqFormDrawer.displayName = "FaqFormDrawer";
export default FaqFormDrawer;
